// extracted by mini-css-extract-plugin
export default {"root":"iLunGAeX","emptyResurseText":"p1c5zbHe"};